import { compose, lifecycle } from 'recompose';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import { selectors as settingsSelectors } from 'state/settings';
import { actions as orderActions } from 'state/order';

import Form from 'refactored/features/soForm/steps/card/creditCard/Form/component';

const enhance = compose(
  withTranslation('CreditCard'),
  connect(
    (state) => ({
      country: settingsSelectors.getCountrySettings(state),
    }),
    {
      fetchQuote: orderActions.fetchQuote,
    }
  ),
  lifecycle({
    componentDidMount() {
      const { fetchQuote } = this.props;

      fetchQuote();
    },
  })
);

export default enhance(Form);
